// // Webpack Imports
import Collapse from 'bootstrap/js/dist/collapse'; // for accordion 
import Offcanvas from 'bootstrap/js/dist/offcanvas'; // for accordion 


import menuSticky from "./js-modules/menu-sticky";
import goToAnchor from "./js-modules/goToAnchor";
import menuToggle from "./js-modules/menu-toggle";
import sliderLinked from './js-modules/slider-linked';
import sliderLinkedBg from './js-modules/slider-linked-bg';
import sliderLogo from "./js-modules/slider-logo";
// import sliderTestimonial from "./js-modules/slider-testimonial";
import navHighlighter from './js-modules/navHighlighter';


import heightMenuMobile from './js-modules/heightMenuMobile'
import { fullHeight, minFullHeight } from './helpers/realFullHeight';
import makeMosaique from './js-modules/mosaique';
import lightview from './js-modules/lightview';
import displayMapPoint from './js-modules/mapPoint';


window.addEventListener("DOMContentLoaded", function () {
	menuSticky();
	menuToggle();
	goToAnchor();
	sliderLogo();
	sliderLinked();
	sliderLinkedBg();
	navHighlighter();
	// sliderTestimonial();
	heightMenuMobile();
	lightview();
	makeMosaique();
	fullHeight();
	minFullHeight();
	displayMapPoint();


	window.addEventListener("resize", function () {
		makeMosaique();
		heightMenuMobile()
		menuSticky();
		fullHeight();
		minFullHeight();
		navHighlighter();
		displayMapPoint();
	})

	window.addEventListener("scroll", function () {
		menuSticky();
		navHighlighter();
	})



	var offcanvasElementList = [].slice.call(document.querySelectorAll('.offcanvas'))
	offcanvasElementList.map(function (offcanvasEl) {
		return new Offcanvas(offcanvasEl)
	})



});